import { IntlShape } from 'react-intl';
import { isProd, isStage } from '../constants/config';

export const getHomeHref = (intl: IntlShape): string =>
  isProd
    ? intl.formatMessage({
        id: 'ec.dashboardService.firstLink',
        defaultMessage: 'https://apgsga.ch/de/',
      })
    : isStage
      ? intl.formatMessage({
          id: 'ec.dashboardService.boxBookingStageLink',
          defaultMessage:
            'https://apg-website-2021-private-cloud-stage.apg.divio.cloud/de/aussenwerbung/plakate-online-buchen/',
        })
      : intl.formatMessage({
          id: 'ec.dashboardService.firstLinkDev',
          defaultMessage: 'https://apgsga.ch/de/',
        });
